import React from 'react';
import styled from 'styled-components';

import { Congratulation, Strong } from 'components/shared';
import Well, { WellHeader, WellBody } from 'components/shared/Well';
import { FormHeader } from 'components/shared/form';

const propTypes = {};

function AccessDenied() {
  return (
    <Well>
      <WellHeader key="header">
        <FormHeader title="Access Denied" />
      </WellHeader>

      <WellBody key="body">
        <StyledIncomplete>
          <Congratulation status="warning">
            <Strong>The link is expired. Please connect with your loan officer</Strong>
          </Congratulation>
        </StyledIncomplete>
      </WellBody>
    </Well>
  );
}

const StyledIncomplete = styled.div`
  margin: auto;
  padding: 30px 0 50px;
  max-width: 545px;
  font-size: var(--font-size-s);
  line-height: var(--line-height-base);
  color: #666;
`;

AccessDenied.propTypes = propTypes;

export default AccessDenied;
